<template>
<div class="chapter">
<div class="inner_page">
<div id="toc"><h1 id="toc-title">Another Time</h1><ol class="toc"><li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li><li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li><li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li><li id="toc-li-4"><a href="#/text/ch004#frank-and-amy-194445">Frank and Amy 1944–45</a></li>
<li id="toc-li-16"><span href="#/text/ch016#frank-and-jeanie-194546" title="Link target outside of Sample">Frank and Jeanie 1945–46</span></li>
<li id="toc-li-28"><span href="#/text/ch028#frank-and-imogen-194694" title="Link target outside of Sample">Frank and Imogen 1946–94</span></li>
<li id="toc-li-49"><span href="#/text/ch049#epilogue-9-years-later" title="Link target outside of Sample">Epilogue 9 Years Later</span></li></ol></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?08dc6b21